<!-- <div class="placeholder">
    @switch (data.type) {
        @case ("info") {
            <mat-icon class="info">check_circle</mat-icon>
        }
        @case ("notify") {
            <mat-icon class="notify">info</mat-icon>
        }
        @case ("warn") {
            <mat-icon class="warn">warning</mat-icon>
        }
        @case ("error") {
            <mat-icon class="error">error</mat-icon>
        }
    }
    <div [innerHTML]="data.msg"></div>
</div> -->

<div class="placeholder">
    @switch (data.type) {
        @case ("notify") {
            <mat-icon>info</mat-icon>
        }
        @case ("info") {
            <mat-icon>check_circle</mat-icon>
        }
        @case ("warn") {
            <mat-icon>change_circle</mat-icon>
        }
        @case ("error") {
            <mat-icon>error</mat-icon>
        }
    }
    <div [innerHTML]="data.msg"></div>
</div>